import EnterpriseMembersProvider from './EnterpriseMembers.provider';

export default EnterpriseMembersProvider;